<template>

</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";

export default {
    mounted() {
        if (localStorage.getItem("tool_jump") == 'cloud_transfer') {
            this.goLogin();
            /*
            // 在线工具，演示账号，自动登录
            var loginData = {};
            loginData.email = "demo@multcloud.com";
            loginData.password = "demodemo";
            loginData.rememberMe = false;
            loginData.language = "en-US";
            this.Utils.doUserRequest("sign_in_demo", loginData)
                .then(response => {
                    if (response.status == 200) {
                        this.user = response.user;
                        commonUtils.setUserToLocal(this.user);
                        const host = location.host
                        if (host.indexOf("localhost") != -1) {
                            window.location.href = "http://localhost:8080/mc_project/home_page";
                        } else if (host.indexOf("test.multcloud.com") != -1) {
                            window.location.href = "https://test.multcloud.com/mc_project/home_page";
                        } else {
                            window.location.href = "https://app.multcloud.com/mc_project/home_page";
                        }
                    } else {
                        this.goLogin();
                    }
                }, err => {
                    this.goLogin();
                });
                */
        } else {
            this.goLogin();
        }
    },
    methods: {
        // 用于跳转到登录页
        goLogin() {
            const host = location.host
            if (host.indexOf("localhost") != -1) {
                window.location.href = "http://localhost:8080/share/sign";
            } else if (host.indexOf("test.multcloud.com") != -1) {
                window.location.href = "https://test.multcloud.com/sign";
            } else {
                window.location.href = "https://www.multcloud.com/sign.html";
            }
        }
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/turn_login_page.vue